import { unitApi } from './apis';
import { convertToQueryString } from '@utils';
import {
  GenericItemsResponseInterface,
  RemoveUnitRoleRequestInterface,
  UnitEntityInterface,
  UnitQueryInterface,
  UpdateUnitRoleRequestInterface,
} from '@types';

const ROUTES = {
  getAllUnits: '/',
};

export const getAllUnits = async (
  query: UnitQueryInterface
): Promise<GenericItemsResponseInterface<UnitEntityInterface>> => {
  const response = await unitApi.get(ROUTES.getAllUnits + convertToQueryString(query));
  return response.data;
};

export const assignUnitRole = async (
  unitId: string,
  data: UpdateUnitRoleRequestInterface
): Promise<void> => {
  const response = await unitApi.patch(`/${unitId}/role/`, data);
  return response.data;
};

export const removeUnitRole = async (
  unitId: string,
  data: RemoveUnitRoleRequestInterface
): Promise<void> => {
  const response = await unitApi.post(`/${unitId}/role/`, data);
  return response.data;
};
